<ng-container *transloco="let convert;">
  <div class="edit-posting-form edit-posting-price-fees">
    <h3 class="content-card-title d-none d-sm-none d-md-block">{{convert('sellModule.posting.pricingAndFeesForm.textPricingAndFees')}}</h3>
    <div class="container ps-0 pe-0" >
      <div class="row">
        <div class="col-sm-12 col-md-7">
          <div class="content-card-subtitle">{{convert('sellModule.posting.pricingAndFeesForm.textSetVehiclePrice')}}</div>
          <form name="priceFeesForm" [formGroup]="priceFeesForm" class="price-fees-forms">
            <div class="form-group col-sm-12 col-md-5 ps-0 pe-0 mt-4">
              <label for="opening-price-num-box" id="opening-price-label">{{convert('sellModule.posting.pricingAndFeesForm.textOpeningPrice')}}</label>
              <div class="input-wrapper">
                <span class="dollar-sign" [ngClass]="isFrenchCanadian ? 'canadian' : 'american'">$</span>
                @if (!isFrenchCanadian) {
                  <input
                    mask="separator.0"
                    thousandSeparator=","
                    separatorLimit="100000"
                    class="form-control american-input"
                    name="openingPrice"
                    formControlName="openingPrice"
                    [class.is-invalid]="isInvalidInputOpeningPrice"
                    pattern="{{regPatternForMultiples}}"
                    (blur)="trackPriceFeesFormChanges()"
                    id="opening-price-num-box"
                    aria-labelledby="opening-price-label opening-price-error"
                    required
                    />
                }
                @if (isFrenchCanadian) {
                  <input
                    thousandSeparator=" "
                    separatorLimit="100000"
                    mask="separator.0"
                    class="form-control canadian-input"
                    name="openingPrice"
                    formControlName="openingPrice"
                    [class.is-invalid]="isInvalidInputOpeningPrice"
                    pattern="{{regPatternForMultiples}}"
                    (blur)="trackPriceFeesFormChanges()"
                    id="opening-price-num-box"
                    aria-labelledby="opening-price-label opening-price-error"
                    required
                    />
                }
              </div>
              @if (!isOpeningPriceHasVal) {
                <span class="invalid-feedback">{{errorMsg.openingPrice.reqErr}}</span>
              }
              @if (isOpeningPriceHasVal
                && isValidDefaultOpeningPrice) {
                <span
                class="invalid-feedback">{{errorMsg.openingPrice.defaultOpeningPriceErr}} {{defaultFormattedOpeningPrice}}.</span>
              }
              @if (isOpeningPriceHasVal
                && !isValidDefaultOpeningPrice
                && openingPrice?.errors?.pattern) {
                <span
                  class="invalid-feedback">{{errorMsg.multiplesPatternErr}}
                </span>
              }
            </div>
            <div class="form-group col-sm-12 col-md-5 ps-0 pe-0" [hidden]="!buyNowAllowed">
              <label for="buynow-price-num-box" id="buynow-price-label">{{convert('sellModule.posting.pricingAndFeesForm.labelBuyNowPrice')}}</label>
              <div class="input-wrapper">
                <span class="dollar-sign" [ngClass]="isFrenchCanadian ? 'canadian' : 'american'">$</span>
                @if (!isFrenchCanadian) {
                  <input
                    mask="separator.0"
                    thousandSeparator=","
                    separatorLimit="100000"
                    class="form-control american-input"
                    name="buyNowPrice"
                    formControlName="buyNowPrice"
                    [class.is-invalid]="priceFeesForm?.touched && (isBuyNowValueIsInvalid || buyNowPrice?.errors?.pattern)"
                    pattern="{{regPatternForMultiples}}"
                    (blur)="trackPriceFeesFormChanges()"
                    id="buynow-price-num-box"
                    aria-labelledby="buynow-price-label buynow-price-error"
                    />
                }
                @if (isFrenchCanadian) {
                  <input
                    mask="separator.0"
                    thousandSeparator=" "
                    separatorLimit="100000"
                    class="form-control canadian-input"
                    name="buyNowPrice"
                    formControlName="buyNowPrice"
                    [class.is-invalid]="priceFeesForm?.touched && (isBuyNowValueIsInvalid || buyNowPrice?.errors?.pattern)"
                    pattern="{{regPatternForMultiples}}"
                    (blur)="trackPriceFeesFormChanges()"
                    id="buynow-price-num-box"
                    aria-labelledby="buynow-price-label buynow-price-error"
                    />
                }
              </div>
              @if (isBuyNowValueIsInvalid) {
                <span class="invalid-feedback">{{errorMsg.buyNowPrice.exceedsOpeningPriceErr}}</span>
              }
              @if (!isBuyNowValueIsInvalid
                && buyNowPrice?.errors?.pattern) {
                <span
                class="invalid-feedback">{{errorMsg.multiplesPatternErr}}</span>
              }
            </div>
            <div class="form-group col-sm-12 col-md-8 ps-0 pe-0">
              <label class="d-block text-start" for="seller-cmts-box">{{convert('sellModule.posting.pricingAndFeesForm.labelSellerComment')}}</label>
              <textarea
                id="seller-cmts-box"
                class="form-control"
                rows="6"
                maxlength="40"
                (blur)="trackPriceFeesFormChanges()"
                (input)="restrictFormCharacters()"
                formControlName="sellerComments"
                appCharacterCount
                #comment="appCharacterCount"
              ></textarea>
              <div class="d-flex justify-content-between">
                <span class="seller-cmts-fee-msg label-font-size" [innerHTML]="convert('sellModule.posting.pricingAndFeesForm.textNote' ,{auctionCmtFormattedFee : feeFormatCurrency(auctionCmtFormattedFee)})"></span>
                <app-character-count
                  [count]="comment.count$ | async"
                  [maxLength]="40"
                  [characterCountTranslate]="characterCountData">
                </app-character-count>
              </div>
            </div>
          </form>
          @if (!isHideSellAndPostFeesEnabled) {
            <div class="price-fees-sale label-font-size">
              <span class="pe-1 fw-bold">{{convert('sellModule.posting.pricingAndFeesForm.labelSaleFee')}}</span>
              <span>{{feeFormatCurrency(saleFormattedFee)}} {{convert('sellModule.posting.pricingAndFeesForm.textApplicable')}}</span>
            </div>
            <div class="price-fees-posting mt-4 label-font-size">
              <span class="pe-1 fw-bold label-font-size">{{convert('sellModule.posting.pricingAndFeesForm.labelPostingFee')}}</span>
              <span>{{feeFormatCurrency(postingFormattedFee)}}</span>
            </div>
          }
        </div>
        <div class="col-sm-12 col-md-5">
          <div class="price-fees-book-val-sec">
            <form name="remainingDaysForm" [formGroup]="remainingDaysForm">
              @if (isNotNewPost) {
                <div class="price-fees-hits-days d-flex justify-content-end">
                  <div>{{convert('sellModule.posting.pricingAndFeesForm.labelHits')}} <span>{{hitCount}}</span></div>
                  <div class="divider">|</div>
                  <div class="price-fees-rem-days">{{convert('sellModule.posting.pricingAndFeesForm.labelRemainingDays')}}
                    @if (!isRemainingDaysEditable) {
                      <span>{{remainingDays}}</span>
                    }
                    @if (isRemainingDaysEditable) {
                      <input
                        mask="separator.0"
                        separatorLimit="10"
                        name="remainingDays"
                        formControlName="remainingDays"
                        class="form-control"
                        [class.is-invalid]="isInvalidRemainingDays"
                        pattern="{{regPatternForMultiples}}"
                        (blur)="trackRemainingDaysFormChanges()"
                        id="remaining-days-num-box"
                        aria-labelledby="price-fees-rem-days"
                        required
                        />
                    }
                  </div>
                </div>
              }
              @if (isInvalidRemainingDays && isRemainingDaysEditable) {
                <span
                class="invalid-feedback d-flex justify-content-end">{{convert('sellModule.posting.multiErrorModal.INVALID_REMAINING_DAYS')}}</span>
              }
            </form>


            <div class="mt-3">
              <div class="d-flex justify-content-between">
                <h4 class="fw-bold">{{convert('sellModule.posting.pricingAndFeesForm.textBookValue')}}</h4>
              </div>
              <div class="content-card-subtitle">{{convert('sellModule.posting.pricingAndFeesForm.textVehicleEstimate')}}</div>
            </div>
            <div class="mt-4">
              @if (bookValueRecalculationInProgress) {
                <div class="text-center">
                  <app-spinner></app-spinner>
                </div>
              }
              @if (!bookValueRecalculationInProgress) {
                <app-book-value-tabs
                  [isCanadianTenantEnabled]="isCanadianTenantEnabled"
                  [isMMREnabled]="isBookValuationManheimValuationEnabled"
                  [bookProviderName]="bookProviderName"
                  [blackBookValues]="blackBookValues"
                  [nadaValues]="nadaValues"
                  [manheimValues]="manheimValues"
                  [formattedBlackBookValues]="formattedBlackBookValues"
                  [formattedNadaValues]="formattedNadaValues"
                  [formattedManheimValues]="formattedManheimValues"
                  [(tabFocus)]="bookValue"
                  [bookValueTabs]="bookValueTrans"
                  [hideShowMoreDetails]="!showMoreDetails"
                  (openExtendedBook)="openBookValueModal($event)">
                </app-book-value-tabs>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (auctionItem && inventoryItem) {
    <app-book-value-modal [auctionItemUuid]="auctionItem.auctionItemUuid"
      [itemDetail]="inventoryItem.itemDetail"
      [vehicleTitle]="vehicleTitle"
      [recalculatedBookValueData]="recalculatedOrganizedModalData"
    ></app-book-value-modal>
  } @else {
    <app-book-value-modal
      [recalculatedBookValueData]="recalculatedOrganizedModalData"
      [newPostVin]="postingData?.inventoryItem?.vehicleInformation?.vin"
      [newPostOdometer]="postingData?.inventoryItem?.vehicleInformation?.odometer"
    ></app-book-value-modal>
  }
</ng-container>
